import { createContext } from 'react'
import { FieldControllerProps } from '../types/Field.types'

// Context for sharing props between compound components
export const FieldControllerContext = createContext<Partial<FieldControllerProps>>({})
